function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M75.68,57.2c0-6.29-5.1-11.39-11.39-11.39h-26.35l5.18-5.18c1.4-1.4,1.62-3.89.29-5.37-1.47-1.63-3.98-1.68-5.51-.15l-9.13,9.13c-2.97,2.96-2.97,7.77,0,10.74l9.02,9.02c1.31,1.31,3.39,1.63,4.92.58,2.03-1.39,2.22-4.19.56-5.84l-5.33-5.33h26.35c2.1,0,3.8,1.7,3.8,3.8v5.01c0,2.1,1.7,3.8,3.8,3.8h0c2.1,0,3.8-1.7,3.8-3.8v-5.01Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeBack);
export default __webpack_public_path__ + "static/media/acae_back.c8cc1a9e.svg";
export { ForwardRef as ReactComponent };